__turbopack_context__.v({
  "expandableContent": "ZfCtbG_expandableContent",
  "productSets": "ZfCtbG_productSets",
  "root": "ZfCtbG_root",
  "tabletContent": "ZfCtbG_tabletContent",
  "webContent": "ZfCtbG_webContent",
});
